<template>
  <b-modal
    id="supplierOrderView-modal"
    ref="supplierOrderView_modal"
    title="Podgląd zamówienia"
    @hidden="onClose"
    size="xl"
  >
    <p class="mb-0" v-html="selectedOrder.content"></p>
    <template v-slot:modal-footer="{ cancel }">
      <b-button size="md" variant="outline-primary" @click="cancel()">
        Powrót
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "SupplierOrderViewModal",
  components: {},
  props: {
    selectedOrder: { type: Object },
  },
  data() {
    return {};
  },
  computed: {
  },
  methods: {
    onClose() {
      this.$bvModal.hide("supplierOrders-modal");
      this.$emit("onClose");
    },
    cancel() {
      this.onClose();
    },
  },
};
</script>
